module.exports = __webpack_public_path__ + "assets/img/650500.1103a565.png";